import { AlertTriangle, Syringe } from "lucide-react";

import { BarChartCard } from "./BarChartCard";
import { formatCount } from "./chartPalette";
import { ChartsGrid, InsightsPanel, StatsRow } from "./InsightsLayout";
import { StatCard } from "./StatCard";
import { TrendChartCard } from "./TrendChartCard";

export const ImmunisationsInsights = ({ insights, isLoading }) => {
  const reactionCount = insights?.reactionCount ?? 0;

  return (
    <InsightsPanel>
      <StatsRow>
        <StatCard label="Total Given" icon={Syringe} isLoading={isLoading}
          value={formatCount(insights?.totalGiven)} />
        <StatCard label="Reactions Reported" icon={AlertTriangle} isLoading={isLoading}
          tone={reactionCount > 0 ? "warning" : "neutral"} value={formatCount(reactionCount)} />
      </StatsRow>
      <ChartsGrid>
        <BarChartCard title="Top Vaccines Administered" data={insights?.byVaccine} isLoading={isLoading} />
        <TrendChartCard title="Immunisations Over Time" data={insights?.trendByDay} isLoading={isLoading} />
      </ChartsGrid>
    </InsightsPanel>
  );
};
